import React, { useEffect, useState } from "react";
import { useMicrophone } from "../context/MicContext";
import { Select, Option, Box, Typography } from "@mui/joy";
import { Mic } from "@mui/icons-material";
import PropTypes from "prop-types";

const MicrophoneSelect = ({ disabled }) => {
  const { selectedMic, microphones, loadPermissionsAndMicrophones, swapMicrophones } = useMicrophone();
  const [ stateMics, setStateMics ] = useState([]);

  const handleChange = (e, mic) => {
    if (!mic) return;
    swapMicrophones(mic);
  };

  useEffect(() => {
    setStateMics(microphones)
  }, [microphones])

  useEffect(() => {
    const loadConsistently = async () => {
      await loadPermissionsAndMicrophones();
    };
    loadConsistently();
  }, [])

  return (
    <Box sx={{ width: "fit-content" }}>
      <Typography level="body-sm"> Audio Source </Typography>
      <Select
        id="microphone-select"
        value={selectedMic}
        onChange={handleChange}
        disabled={disabled}
        startDecorator={
          <Mic />
        }
      >
        <Option value="" disabled>
          Select a microphone
        </Option>
        {stateMics && stateMics.map((mic) => (
          <Option key={mic.deviceId} value={mic.deviceId}>
            {mic.label || `Microphone ${mic.deviceId}`}
          </Option>
        ))}
      </Select>
    </Box>
  );
};

MicrophoneSelect.propTypes = {
  disabled: PropTypes.bool,
};

export default MicrophoneSelect;
